import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../helpers/Firebase';
import { servicePath } from '../../constants/defaultValues';
import { 
  SEARCH_DOCUMENT_TYPE,
  SEARCH_EQUIPMENT_DELIVERY_ORDER,
  SEARCH_DELIVERY_ORDER_LINE_LOT,
  SEARCH_DELIVERY_ORDER_LINE,
  SEARCH_STATUS_REVIEW,
  SEARCH_EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL,
  SEARCH_CATEGORY_MAINTENANCE_DELAY,
  SEARCH_HOSPITAL_SECTION,
  SEARCH_HOSPITAL_SERVICE,
  SEARCH_REQUEST_TYPE,
  SEARCH_REQUEST_TYPE_DETAIL,
  SEARCH_PRIORITY,
  SEARCH_REQUEST_STATUS,
  SEARCH_REQUEST_PROCESS_TYPE,
  SEARCH_ACTION_REQUEST,
  SEARCH_HEALTH_REGISTRY_AGENCY,
  SEARCH_BMP_AGENCY,
  SEARCH_RISK_TYPE,
  SEARCH_GHTF,
  SEARCH_DIAGNOSTIC_CLASS,
  SEARCH_ISO,
  SEARCH_GT_CERTIFICATE,
  SEARCH_SERVICE_TYPE,
  SEARCH_BIOEQUIVALENCE,
  SEARCH_VEHICLE_TYPE,
  SEARCH_FREQUENCY_MTO,
  SEARCH_AMBULANCE_PLATE,
  SEARCH_AMBULANCE_CHASIS,
  SEARCH_AMBULANCE_CODE_IGSS
} from '../actions';

import {
  SearchDocumentTypeSuccess,
  SearchDocumentTypeError,
  SearchEquipmentDeliveryOrderSuccess,
  SearchEquipmentDeliveryOrderError,
  SearchDeliveryOrderLineLotSuccess,
  SearchDeliveryOrderLineLotError,
  SearchDeliveryOrderLineSuccess,
  SearchDeliveryOrderLineError,
  SearchStatusReviewSuccess,
  SearchStatusReviewError,
  SearchEquipmentScheduleMaintenanceDetailSuccess,
  SearchEquipmentScheduleMaintenanceDetailError,
  SearchCategoryMaintenanceDelaySuccess,
  SearchCategoryMaintenanceDelayError,
  SearchHospitalSectionSuccess,
  SearchHospitalSectionError,
  SearchHospitalServiceSuccess,
  SearchHospitalServiceError,
  SearchRequestTypeSuccess,
  SearchRequestTypeError,
  SearchRequestTypeDetailSuccess,
  SearchRequestTypeDetailError,
  SearchPrioritySuccess,
  SearchPriorityError,
  SearchRequestStatusSuccess,
  SearchRequestStatusError,
  SearchRequestProcessTypeSuccess,
  SearchRequestProcessTypeError,
  SearchActionRequestSuccess,
  SearchActionRequestError,
  SearchHealthRegistryAgencySuccess,
  SearchHealthRegistryAgencyError,
  SearchBmpAgencySuccess,
  SearchBmpAgencyError,
  SearchRiskTypeSuccess,
  SearchRiskTypeError,
  SearchGhtfSuccess,
  SearchGhtfError,
  SearchDiagnosticClassSuccess,
  SearchDiagnosticClassError,
  SearchIsoSuccess,
  SearchIsoError,
  SearchGtCertificateSuccess,
  SearchGtCertificateError,
  SearchServiceTypeSuccess,
  SearchServiceTypeError,
  SearchBioequivalenceSuccess,
  SearchBioequivalenceError,
  SearchVehicleTypeSuccess,
  SearchVehicleTypeError,
  SearchFrequencyMtoSuccess,
  SearchFrequencyMtoError,
  SearchAmbulancePlateSuccess,
  SearchAmbulancePlateError,
  SearchAmbulanceChasisSuccess,
  SearchAmbulanceChasisError,
  SearchAmbulanceCodeIgssSuccess,
  SearchAmbulanceCodeIgssError
} from '../actions';


export function* watchSearchDocumentType() {
  yield takeEvery(SEARCH_DOCUMENT_TYPE, onSearchDocumentType);
}

export function* watchSearchEquipmentDeliveryOrder() {
  yield takeEvery(SEARCH_EQUIPMENT_DELIVERY_ORDER, onSearchEquipmentDeliveryOrder);
}

export function* watchSearchDeliveryOrderLineLot() {
  yield takeEvery(SEARCH_DELIVERY_ORDER_LINE_LOT, onSearchDeliveryOrderLineLot);
}

export function* watchSearchDeliveryOrderLine() {
  yield takeEvery(SEARCH_DELIVERY_ORDER_LINE, onSearchDeliveryOrderLine);
}

export function* watchSearchStatusReview() {
  yield takeEvery(SEARCH_STATUS_REVIEW, onSearchStatusReview);
}

export function* watchSearchEquipmentScheduleMaintenanceDetail() {
  yield takeEvery(SEARCH_EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL, onSearchEquipmentScheduleMaintenanceDetail);
}

export function* watchSearchCategoryMaintenanceDelay() {
  yield takeEvery(SEARCH_CATEGORY_MAINTENANCE_DELAY, onSearchCategoryMaintenanceDelay);
}

export function* watchSearchHospitalSection() {
  yield takeEvery(SEARCH_HOSPITAL_SECTION, onSearchHospitalSection);
}

export function* watchSearchHospitalService() {
  yield takeEvery(SEARCH_HOSPITAL_SERVICE, onSearchHospitalService);
}

export function* watchSearchRequestType() {
  yield takeEvery(SEARCH_REQUEST_TYPE, onSearchRequestType);
}

export function* watchSearchRequestTypeDetail() {
  yield takeEvery(SEARCH_REQUEST_TYPE_DETAIL, onSearchRequestTypeDetail);
}

export function* watchSearchPriority() {
  yield takeEvery(SEARCH_PRIORITY, onSearchPriority);
}

export function* watchSearchRequestStatus() {
  yield takeEvery(SEARCH_REQUEST_STATUS, onSearchRequestStatus);
}

export function* watchSearchRequestProcessType() {
  yield takeEvery(SEARCH_REQUEST_PROCESS_TYPE, onSearchRequestProcessType);
}

export function* watchSearchActionRequest() {
  yield takeEvery(SEARCH_ACTION_REQUEST, onSearchActionRequest);
}

export function* watchSearchHealthRegistryAgency() {
  yield takeEvery(SEARCH_HEALTH_REGISTRY_AGENCY, onSearchHealthRegistryAgency);
}

export function* watchSearchBmpAgency() {
  yield takeEvery(SEARCH_BMP_AGENCY, onSearchBmpAgency);
}

export function* watchSearchRiskType() {
  yield takeEvery(SEARCH_RISK_TYPE, onSearchRiskType);
}

export function* watchSearchGhtf() {
  yield takeEvery(SEARCH_GHTF, onSearchGhtf);
}

export function* watchSearchDiagnosticClass() {
  yield takeEvery(SEARCH_DIAGNOSTIC_CLASS, onSearchDiagnosticClass);
}

export function* watchSearchIso() {
  yield takeEvery(SEARCH_ISO, onSearchIso);
}

export function* watchSearchGtCertificate() {
  yield takeEvery(SEARCH_GT_CERTIFICATE, onSearchGtCertificate);
}

export function* watchSearchServiceType() {
  yield takeEvery(SEARCH_SERVICE_TYPE, onSearchServiceType);
}

export function* watchSearchBioequivalence() {
  yield takeEvery(SEARCH_BIOEQUIVALENCE, onSearchBioequivalence);
}

export function* watchSearchVehicleType() {
  yield takeEvery(SEARCH_VEHICLE_TYPE, onSearchVehicleType);
}

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onSearchDocumentTypeAsync = async (payload) => { 
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/document_type', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())   
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchEquipmentDeliveryOrderAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/equipment_delivery_order', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ; 
};

const onSearchDeliveryOrderLineLotAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/delivery_order_line_lot', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchDeliveryOrderLineAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/delivery_order_line', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchStatusReviewAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/status_review', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchEquipmentScheduleMaintenanceDetailAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/equipment_schedule_maintenance_detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};


const onSearchCategoryMaintenanceDelayAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/category_maintenance_delay', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json' , 'token': token },
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchHospitalSectionAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/hospital_section', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchHospitalServiceAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/hospital_service', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchRequestTypeAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/request_type', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchRequestTypeDetailAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/request_type_detail', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchPriorityAsync = async () => {
  const response = await fetch(servicePath + 'search/priority', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json'}
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchRequestStatusAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/request_status', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchRequestProcessTypeAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/request_process_type', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchActionRequestAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/action_request', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchHealthRegistryAgencyAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/health_registry_agency', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchBmpAgencyAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/bmp_agency', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchRiskTypeAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/risk_type', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchGhtfAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/ghtf', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchDiagnosticClassAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/diagnostic_class', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchIsoAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/iso', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchGtCertificateAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/gt_certificate', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchServiceTypeAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/service_type', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchBioequivalenceAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/bioequivalence', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchVehicleTypeAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/vehicle_type', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response;
};

function* onSearchDocumentType(data) {
  try {
    const response = yield call(onSearchDocumentTypeAsync, data.payload);
    yield put(SearchDocumentTypeSuccess(response.data));
  } catch (error) {
    yield put(SearchDocumentTypeError(error));
  }
}

function* onSearchEquipmentDeliveryOrder(data) {
  try {
    const response = yield call(onSearchEquipmentDeliveryOrderAsync, data.payload);
    yield put(SearchEquipmentDeliveryOrderSuccess(response.data));
  } catch (error) {
    yield put(SearchEquipmentDeliveryOrderError(error));
  }
}

function* onSearchDeliveryOrderLineLot(data) {
  try {
    const response = yield call(onSearchDeliveryOrderLineLotAsync, data.payload);
    yield put(SearchDeliveryOrderLineLotSuccess(response.data));
  } catch (error) {
    yield put(SearchDeliveryOrderLineLotError(error));
  }
}

function* onSearchDeliveryOrderLine(data) {
  try {
    const response = yield call(onSearchDeliveryOrderLineAsync, data.payload);
    yield put(SearchDeliveryOrderLineSuccess(response.data));
  } catch (error) {
    yield put(SearchDeliveryOrderLineError(error));
  }
}

function* onSearchStatusReview(data) {
  try {
    const response = yield call(onSearchStatusReviewAsync, data.payload);
    yield put(SearchStatusReviewSuccess(response.data));
  } catch (error) {
    yield put(SearchStatusReviewError(error));
  }
}

function* onSearchEquipmentScheduleMaintenanceDetail(data) { 
  try {
    const response = yield call(onSearchEquipmentScheduleMaintenanceDetailAsync, data.payload);
    yield put(SearchEquipmentScheduleMaintenanceDetailSuccess(response.data));
  } catch (error) {
    yield put(SearchEquipmentScheduleMaintenanceDetailError(error));
  }
}

function* onSearchCategoryMaintenanceDelay(data) {
  try {
    const response = yield call(onSearchCategoryMaintenanceDelayAsync, data);
    yield put(SearchCategoryMaintenanceDelaySuccess(response.data));
  } catch (error) {
    yield put(SearchCategoryMaintenanceDelayError(error));
  }
}

function* onSearchHospitalSection(data) {
  try {
    const response = yield call(onSearchHospitalSectionAsync, data.payload);
    yield put(SearchHospitalSectionSuccess(response.data));
  } catch (error) {
    yield put(SearchHospitalSectionError(error));
  }
}

function* onSearchHospitalService(data) {
  try {
    const response = yield call(onSearchHospitalServiceAsync, data);
    yield put(SearchHospitalServiceSuccess(response.data));
  } catch (error) {
    yield put(SearchHospitalServiceError(error));
  }
}

function* onSearchRequestType(data) {
  try {
    const response = yield call(onSearchRequestTypeAsync, data);
    yield put(SearchRequestTypeSuccess(response.data));
  } catch (error) {
    yield put(SearchRequestTypeError(error));
  }
}

function* onSearchRequestTypeDetail(data) {
  try {
    const response = yield call(onSearchRequestTypeDetailAsync, data);
    yield put(SearchRequestTypeDetailSuccess(response.data));
  } catch (error) {
    yield put(SearchRequestTypeDetailError(error));
  }
}

function* onSearchPriority(data) {
  try {
    const response = yield call(onSearchPriorityAsync, data);
    yield put(SearchPrioritySuccess(response.data));
  } catch (error) {
    yield put(SearchPriorityError(error));
  }
}

function* onSearchRequestStatus(data) {
  try {
    const response = yield call(onSearchRequestStatusAsync, data.payload);
    yield put(SearchRequestStatusSuccess(response.data));
  } catch (error) {
    yield put(SearchRequestStatusError(error));
  }
}

function* onSearchRequestProcessType(data) {
  try {
    const response = yield call(onSearchRequestProcessTypeAsync, data.payload);
    yield put(SearchRequestProcessTypeSuccess(response.data));
  } catch (error) {
    yield put(SearchRequestProcessTypeError(error));
  }
}

function* onSearchActionRequest(data) {
  try {
    const response = yield call(onSearchActionRequestAsync, data.payload);
    yield put(SearchActionRequestSuccess(response.data));
  } catch (error) {
    yield put(SearchActionRequestError(error));
  }
}

function* onSearchHealthRegistryAgency(data) {
  try {
    const response = yield call(onSearchHealthRegistryAgencyAsync, data.payload);
    yield put(SearchHealthRegistryAgencySuccess(response.data));
  } catch (error) {
    yield put(SearchHealthRegistryAgencyError(error));
  }
}

function* onSearchBmpAgency(data) {
  try {
    const response = yield call(onSearchBmpAgencyAsync, data.payload);
    yield put(SearchBmpAgencySuccess(response.data));
  } catch (error) {
    yield put(SearchBmpAgencyError(error));
  }
}

function* onSearchRiskType(data) {
  try {
    const response = yield call(onSearchRiskTypeAsync, data.payload);
    yield put(SearchRiskTypeSuccess(response.data));
  } catch (error) {
    yield put(SearchRiskTypeError(error));
  }
}

function* onSearchGhtf(data) {
  try {
    const response = yield call(onSearchGhtfAsync, data.payload);
    yield put(SearchGhtfSuccess(response.data));
  } catch (error) {
    yield put(SearchGhtfError(error));
  }
}

function* onSearchDiagnosticClass(data) {
  try {
    const response = yield call(onSearchDiagnosticClassAsync, data.payload);
    yield put(SearchDiagnosticClassSuccess(response.data));
  } catch (error) {
    yield put(SearchDiagnosticClassError(error));
  }
}

function* onSearchIso(data) {
  try {
    const response = yield call(onSearchIsoAsync, data.payload);
    yield put(SearchIsoSuccess(response.data));
  } catch (error) {
    yield put(SearchIsoError(error));
  }
}

function* onSearchGtCertificate(data) {
  try {
    const response = yield call(onSearchGtCertificateAsync, data.payload);
    yield put(SearchGtCertificateSuccess(response.data));
  } catch (error) {
    yield put(SearchGtCertificateError(error));
  }
}

function* onSearchServiceType(data) {
  try {
    const response = yield call(onSearchServiceTypeAsync, data.payload);
    yield put(SearchServiceTypeSuccess(response.data));
  } catch (error) {
    yield put(SearchServiceTypeError(error));
  }
}

function* onSearchBioequivalence(data) {
  try {
    const response = yield call(onSearchBioequivalenceAsync, data.payload);
    yield put(SearchBioequivalenceSuccess(response.data));
  } catch (error) {
    yield put(SearchBioequivalenceError(error));
  }
}

function* onSearchVehicleType(data) {
  try {
    const response = yield call(onSearchVehicleTypeAsync, data.payload);
    yield put(SearchVehicleTypeSuccess(response.data));
  } catch (error) {
    yield put(SearchVehicleTypeError(error));
  }
}

const onSearchFrequencyMtoAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/frequency_mto', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response;
};

export function* watchSearchFrequencyMto() {
  yield takeEvery(SEARCH_FREQUENCY_MTO, onSearchFrequencyMto);
}

function* onSearchFrequencyMto(data) {
  try {
    const response = yield call(onSearchFrequencyMtoAsync);
    yield put(SearchFrequencyMtoSuccess(response.data));
  } catch (error) {
    yield put(SearchFrequencyMtoError(error));
  }
}

const onSearchAmbulancePlateAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/ambulance_plate', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response;
};

export function* watchSearchAmbulancePlate() {
  yield takeEvery(SEARCH_AMBULANCE_PLATE, onSearchAmbulancePlate);
}

function* onSearchAmbulancePlate() {
  try {
    const response = yield call(onSearchAmbulancePlateAsync);
    yield put(SearchAmbulancePlateSuccess(response.data));
  } catch (error) {
    yield put(SearchAmbulancePlateError(error));
  }
}

const onSearchAmbulanceChasisAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/ambulance_chasis', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response;
};

export function* watchSearchAmbulanceChasis() {
  yield takeEvery(SEARCH_AMBULANCE_CHASIS, onSearchAmbulanceChasis);
}

function* onSearchAmbulanceChasis() {
  try {
    const response = yield call(onSearchAmbulanceChasisAsync);
    yield put(SearchAmbulanceChasisSuccess(response.data));
  } catch (error) {
    yield put(SearchAmbulanceChasisError(error));
  }
}

const onSearchAmbulanceCodeIgssAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/ambulance_code_igss', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response;
};

export function* watchSearchAmbulanceCodeIgss() {
  yield takeEvery(SEARCH_AMBULANCE_CODE_IGSS, onSearchAmbulanceCodeIgss);
}

function* onSearchAmbulanceCodeIgss() {
  try {
    const response = yield call(onSearchAmbulanceCodeIgssAsync);
    yield put(SearchAmbulanceCodeIgssSuccess(response.data));
  } catch (error) {
    yield put(SearchAmbulanceCodeIgssError(error));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchSearchDocumentType),
    fork(watchSearchEquipmentDeliveryOrder),
    fork(watchSearchEquipmentScheduleMaintenanceDetail),
    fork(watchSearchCategoryMaintenanceDelay),
    fork(watchSearchHospitalSection),
    fork(watchSearchHospitalService),
    fork(watchSearchRequestType),
    fork(watchSearchRequestTypeDetail),
    fork(watchSearchPriority),
    fork(watchSearchRequestStatus),
    fork(watchSearchRequestProcessType),
    fork(watchSearchActionRequest),
    fork(watchSearchHealthRegistryAgency),
    fork(watchSearchBmpAgency),
    fork(watchSearchRiskType),
    fork(watchSearchGhtf),
    fork(watchSearchDiagnosticClass),
    fork(watchSearchIso),
    fork(watchSearchGtCertificate),
    fork(watchSearchServiceType),
    fork(watchSearchDeliveryOrderLineLot),
    fork(watchSearchDeliveryOrderLine),
    fork(watchSearchStatusReview),
    fork(watchSearchBioequivalence),
    fork(watchSearchVehicleType),
    fork(watchSearchFrequencyMto),
    fork(watchSearchAmbulancePlate),
    fork(watchSearchAmbulanceChasis),
    fork(watchSearchAmbulanceCodeIgss)
  ]);
}